<template>
  <div>
    <CRow>
      <CCol col="12" md="12" lg="12">
        <h4>
          <strong>{{ $store.state.form.dataPotongan }}</strong>
        </h4>
        <hr />
      </CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <b-form>
          <b-form-group :label="$store.state.form.namaPotongan" label-cols-md="3">
            <b-form-select :options="potongan" v-model="dataPotongan.namaPotongan" @input="setNominal(dataPotongan.namaPotongan)"></b-form-select>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.jenisPotongan" label-cols-md="3">
            <b-form-input disabled type="text" v-model="dataPotongan.jenisPotongan"></b-form-input>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.nominalPotongan" label-cols-md="3">
            <b-form-input :disabled="dataPotongan.jenisPotongan == 'Tetap'" type="number" v-model="dataPotongan.nominalPotongan"></b-form-input>
          </b-form-group>
        </b-form>

        <b-form>
          <b-form-group :label="$store.state.form.keterangan" label-cols-md="3">
            <b-form-textarea v-model="dataPotongan.keteranganPotongan"></b-form-textarea>
          </b-form-group>
        </b-form>

        <b-button variant="primary" @click="simpan()"> <CIcon name="cil-plus" /> {{ $store.state.form.tambahData }} </b-button>
      </CCol>
    </CRow>

    <CRow class="mt-3">
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy">
          <template #statusPotongan="{ item }">
            <td>
              <span v-if="item.statusPotongan == 1">
                {{ $store.state.form.lunas }}
              </span>
              <span v-else>
                {{ $store.state.form.berjalan }}
              </span>
            </td>
          </template>

          <template #actions="{ item }">
            <td>
              <b-button
                v-if="item.jenisPotongan == 'Tidak Tetap' && item.statusPotongan == 0"
                variant="danger"
                class="mr-1"
                v-c-tooltip.hover.click="$store.state.table.tooltipLunas"
                v-b-modal.modal-lunas
                @click="pelunasan = item"
              >
                <CIcon name="cil-trash" />
              </b-button>
            </td>
          </template>
        </CDataTable>
      </CCol>
    </CRow>

    <div>
      <b-modal id="modal-lunas" size="lg" centered scrollable :title="$store.state.form.modalLunasTitle" header-bg-variant="info" header-text-variant="light">
        <p>
          {{ $store.state.form.konfirmasiLunas }}
          <span class="text-danger">{{ data.namaKaryawan }}</span> pada <span class="text-danger">{{ pelunasan.namaPotongan }}</span> senilai
          <span class="text-danger">{{ pelunasan.nominalPotongan }}</span
          >?
        </p>

        <template #modal-footer>
          <b-button variant="secondary" @click="$bvModal.hide('modal-lunas')">
            {{ $store.state.form.batal }}
          </b-button>
          <b-button variant="primary" @click="lunas()">
            {{ $store.state.form.yakin }}
          </b-button>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
// import modalDelete from "./modalDelete.vue";
export default {
  components: {
    // DatePicker,
    // modalDelete,
  },
  props: ["data", "activeTab"],
  data() {
    return {
      items: [],
      dataPotongan: {
        namaPotongan: "",
        nominalPotongan: "",
        jenisPotongan: "",
        keterangan: "",
        statusPotongan: 0,
      },
      pelunasan: "",
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sortable: true,
          class: "table-number text-center",
        },
        {
          key: "namaPotongan",
          label: "Nama Potongan",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "namaNominalPotongan",
          label: "Nominal Potongan",
          sortable: true,
          sortDirection: "desc",
          class: "text-right",
        },

        {
          key: "jenisPotongan",
          label: "Jenis Potongan",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "namaTanggalLunas",
          label: "Tanggal Lunas",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "statusPotongan",
          label: "Status",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          class: "table-option-3 text-center",
        },
      ],
      potongan: [],
      tableBusy: false,
    };
  },
  computed: {},
  mounted() {
    // this.getDatas();
  },
  watch: {
    "data.dataKaryawanId"(newVar, oldVar) {
      if (newVar != oldVar) {
        this.getDatas();
      }
    },
    activeTab(newVar) {
      if (newVar == 4) {
        this.getDatas();
      }
    },
  },
  methods: {
    convert(x) {
      if (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    setNominal(x) {
      console.log(x);
      this.potongan.forEach((item) => {
        if (item.masterPotonganId == x) {
          this.dataPotongan.nominalPotongan = item.nominalPotongan;
          this.dataPotongan.jenisPotongan = item.jenisPotongan;
          this.dataPotongan.masterPotonganId = item.id;
        }
      });
    },
    async getDatas() {
      let vm = this;
      let potongan = await vm.$axios.post("masterPotongan/list");
      // console.log(potongan);

      vm.potongan = potongan.data.data.map((item) => {
        return { ...item, value: item.masterPotonganId, text: item.namaPotongan };
      });

      // console.log(this.data);
      let potKaryawan = await vm.$axios.post("poolPotongan/listPoolPotonganByDataKaryawanId/", { dataKaryawanId: vm.$route.query.dataKaryawanId });

      vm.items = potKaryawan.data.data;
      this.totalRows = vm.items.length;
      // console.log(vm.items, "potpot");
      console.log("potKaryawan", potKaryawan);
      vm.items =
        potKaryawan.data.status == 200
          ? potKaryawan.data.data.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
                namaNominalPotongan: vm.convert(x.nominalPotongan),
                namaTanggalLunas: x.tanggalLunas ? vm.$moment(x.tanggalLunas).format("LL") : "-",
              };
            })
          : [];
    },
    lunas() {
      let vm = this;
      // console.log(vm.pelunasan, "pelunasan");
      vm.pelunasan.id = vm.pelunasan.poolPotonganId;
      vm.pelunasan.statusPotongan = 1;
      vm.pelunasan.tanggalLunas = vm.$moment();
      vm.$axios
        .post("poolPotongan/update", vm.pelunasan)
        .then((res) => {
          if (res.data.status == 200) {
            if (res.data.message == "sukses") {
              vm.$bvModal.hide("modal-lunas");
              vm.getDatas();
              vm.busy = false;
              vm.$emit("change");
              vm.variant = "success";
              vm.msg = "BERHASIL MELUNASI POTONGAN";
              vm.showing = true;
              setTimeout(() => {
                vm.showing = false;
              }, 4000);
            } else {
              vm.button = "Simpan";
              vm.busy = false;
              vm.variant = "danger";
              vm.msg = res.data.message.toUpperCase();
              vm.showing = true;
              setTimeout(() => {
                vm.showing = false;
              }, 4000);
            }
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.variant = "danger";
          vm.msg = "TERJADI KESALAHAN PADA SERVER";
          vm.showing = true;
          setTimeout(() => {
            vm.showing = false;
          }, 4000);
        });
    },
    simpan() {
      let vm = this;
      vm.busy = true;
      vm.button = "Mohon Tunggu";
      vm.dataPotongan.masterPotonganId = vm.dataPotongan.namaPotongan;
      vm.dataPotongan.dataKaryawanId = vm.data.dataKaryawanId;
      vm.$axios
        .post("poolPotongan/register", vm.dataPotongan)
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.triggerAlert({
              variant: "success",
              msg: "BERHASIL MENDAFTARKAN POTONGAN",
              showing: true,
            });
            // vm.variant = "success";
            // vm.msg = "BERHASIL MENDAFTARKAN POTONGAN";
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
            this.getDatas();
            vm.$emit("change");
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.triggerAlert({
              variant: "danger",
              msg: res.data.message.toUpperCase(),
              showing: true,
            });
            // vm.variant = "danger";
            // vm.msg = (res.data.message).toUpperCase();
            // vm.showing = true;
            // setTimeout(() => {
            //   vm.showing = false;
            // }, 4000);
          }
        })
        .catch((err) => {
          err;
          vm.button = "Simpan";
          vm.busy = false;
          vm.triggerAlert({
            variant: "danger",
            msg: "TERJADI KESALAHAN PADA SERVER",
            showing: true,
          });
          // vm.variant = "danger";
          // vm.msg = "TERJADI KESALAHAN PADA SERVER";
          // vm.showing = true;
          // setTimeout(() => {
          //   vm.showing = false;
          // }, 4000);
        });
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.$emit("change");
    },
  },
};
</script>
